import { __decorate } from "tslib";
import { action, computed, observable } from 'mobx';
import { EXPANDED_KEY } from './Record';
import { getIf } from './utils';
export default class Group {
    constructor(name, index, value, parentGroup) {
        this.index = index;
        this.name = name;
        this.value = value;
        this.parentGroup = parentGroup;
        this.records = [];
        this.totalRecords = [];
        this.subGroups = [];
    }
    get isExpanded() {
        return this.getState(EXPANDED_KEY) !== false;
    }
    set isExpanded(isExpanded) {
        this.setState(EXPANDED_KEY, isExpanded);
    }
    get level() {
        const { parent } = this;
        if (parent) {
            return parent.level + 1;
        }
        return 0;
    }
    get expandedRecords() {
        const { subGroups } = this;
        if (subGroups.length) {
            return subGroups.reduce((list, group) => {
                const newList = list.concat(group.expandedRecords);
                const { children } = group;
                if (children && group.isExpanded) {
                    return children.reduce((childList, childGroup) => childList.concat(childGroup.expandedRecords), newList);
                }
                return newList;
            }, []);
        }
        return this.records;
    }
    getState(key) {
        const { state } = this;
        return state && state.get(key);
    }
    setState(key, value) {
        if (value !== undefined || this.state) {
            const state = getIf(this, 'state', () => observable.map());
            return state.set(key, value);
        }
    }
}
__decorate([
    observable
], Group.prototype, "state", void 0);
__decorate([
    computed
], Group.prototype, "expandedRecords", null);
__decorate([
    action
], Group.prototype, "setState", null);
